module.exports = __webpack_public_path__ + "img/rm208-280-jj-059_1.0159677d.jpg";